export enum AppLanguage {
    Galician = 'gl',
    Spanish = 'es',
    English = 'en',
}

export const AppLanguages = Object.keys(AppLanguage).map(k => (AppLanguage as any)[k as any]);
export const DefaultLanguage = AppLanguage.Galician;